export default {
  dark: 'Escuro',
  light: 'Claro'
}
